import { env } from '@skin-seoul/env-utils';
import type { GetCookieUserResponse, UpdateUserRequest, UpdateUserResponse, GetUserResponse } from './utils/types';
import { wordpressClient } from '../common/wordpressClient';

class UserAPIClient {
  public async getCookieUser(): Promise<GetCookieUserResponse> {
    if (env('NEXT_PUBLIC_ENV') === 'LOCAL') {
      return {
        id: 725,
        username: 'jason',
        email: 'jason@skin-seoul.com',
        display_name: 'jason',
        roles: ['administrator'],
        cookie_source: 'wordpress_logged_in',
      };
    }
    try {
      const res = await wordpressClient.get('/wp-json/skinseoul/v1/cookie-user');
      const response = await res.data;
      return response;
    } catch (e: unknown) {
      if (e instanceof Response && (e.status === 401 || e.status === 403)) {
        return null;
      }
      return null;
    }
  }

  public async updateUser(payload: UpdateUserRequest): Promise<UpdateUserResponse> {
    if (env('NEXT_PUBLIC_ENV') === 'LOCAL') {
      return payload as unknown as UpdateUserResponse;
    }
    try {
      const res = await wordpressClient.put('/wp-json/skinseoul/v1/user', payload);
      return res.data as UpdateUserResponse;
    } catch (_e) {
      console.log(JSON.stringify(_e, null, 2));
      return null as unknown as UpdateUserResponse;
    }
  }

  public async getUser(): Promise<GetUserResponse> {
    if (env('NEXT_PUBLIC_ENV') === 'LOCAL') {
      return {
        userId: 602,
        address: {
          shipping: {
            firstName: 'John',
            lastName: 'Doe',
            address1: '123 Main St',
            address2: 'Apt 4B',
            city: 'New York',
            postcode: '10001',
            country: 'US',
            state: 'NY',
            phone: '+1-555-123-4567',
          },
          billing: {
            firstName: 'John',
            lastName: 'Doe',
            address1: '123 Main St',
            address2: 'Apt 4B',
            city: 'New York',
            postcode: '10001',
            country: 'US',
            state: 'NY',
            phone: '+1-555-123-4567',
          },
        },
        email: {
          emailAddress: 'minchul@skin-seoul.com',
          subscribed: true,
        },
      } satisfies GetUserResponse;
    }
    try {
      const res = await wordpressClient.get('/wp-json/skinseoul/v1/user');
      return res.data as GetUserResponse;
    } catch (_e) {
      return null;
    }
  }
}

export const userAPIClient = new UserAPIClient();
